import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid } from '@material-ui/core';
import Search from '../../../components/Search/Search';
import DataTable from '../../../components/DataTable/DataTable';
import Filters from '../../../components/DataTable/Filters/Filters';
import CustomizeView from '../../../components/DataTable/CustomizeView/CustomizeView';
import ProfileService from '../../../services/ProfileService/ProfileService'
import ActioneerResultDetail from './actioneerResultDetail/ActioneerResultDetail';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import DeleteConfirm from '../../../components/DataTable/DeleteConfirm';
import { personalizationState } from "../../../recoil-store/recoil-state";
import { useRecoilValue } from 'recoil';
import { convertToDateFormat } from '../../../helpers/helper';

/**
 * @Description This function returns Alert Management page.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */

const StatusInput = ({ status }) => {
    return (
        <Brightness1Icon style={{ color: status ? "#43AA41" : "#D75E5E" }} />
    );
};
let deletedAutoms = [];
let setSelectedAutomRow;
function AlertManagement(props) {
    const label = 'CONTENT.ALERT.';
    const { t } = useTranslation();
    const personalization = useRecoilValue(personalizationState);

    const [data, setData] = useState([]);
    const [loading,] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [customColumn, setCustomColumn] = useState([]);
    const [searchKeyData, setSearchKeyData] = useState('');
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);
    const [openDetail, setOpenDetail] = useState({ id: '', isOpen: false });
    const [openDelete, setOpenDelete] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);

    const deleteAutoms = async () => {
        let ids = deletedAutoms;
        setLoadingDelete(true);
        const response = await ProfileService.deleteActioneerResult(ids);
        if (response) {
            if (response.status) {
                setSelectedAutomRow([]);
                fetchData().then((r) => r);
            }
        } else {
            props.showNewAlert(t("GENERAL.NETWORK-ERROR"));
        }
        setLoadingDelete(false);
    };

    const fetchData = async () => {
        const res = await ProfileService.getActioneerResults();
        if (res?.data) {
            setData(res.data);
            setSearchData(res.data);
        }
    };

    const handleRowsDelete = (rowsDeleted, dataArray, setSelectedRows) => {
        setOpenDelete(true);
        deletedAutoms = [];
        for (let i of rowsDeleted.data) {
            deletedAutoms.push(searchData[i.dataIndex].id);
        }
        setSelectedAutomRow = setSelectedRows;
    };

    useEffect(() => { fetchData().then(r => r); }, []);

    useEffect(() => {
        const column = [{
            id: 0,
            name: 'id',
            label: ' ',
            options: {
                filter: false, sort: false,
                customBodyRenderLite: (dataIndex) => {
                    if (searchData && searchData[dataIndex]) {
                        return <span>{dataIndex + 1}.</span>;
                    }
                }
            }
        }, {
            id: 1,
            name: 'status',
            label: t(label + 'STATUS'),
            options: {
                filter: false, sort: false,
                customBodyRenderLite: (dataIndex) => {
                    if (searchData && searchData[dataIndex]) {
                        return <StatusInput status={searchData[dataIndex]?.status} />;
                    }
                }
            }
        }, {
            id: 2,
            name: 'autom_name',
            label: t(label + 'AUTOM-NAME'),
            options: { filter: true, sort: false }
        }, {
            id: 3,
            name: 'action_defination',
            label: t(label + 'ACTION-DEFINATION'),
            options: { filter: true, sort: false }
        }, {
            id: 4,
            name: 'actioneer_profile_type',
            label: t(label + 'ACTIONEER-PROFILE-TYPE'),
            options: { filter: true, sort: false }
        }, {
            id: 5,
            name: 'created_at',
            label: t(label + 'CREATED-AT'),
            options: {
                filter: true, sort: true, display: true,
                customBodyRenderLite: (dataIndex) => {
                    if (searchData[dataIndex]) {
                        return convertToDateFormat(searchData[dataIndex]?.created_at, personalization.date_format)
                    }
                }
            }
        }, {
            id: 6,
            name: 'detail',
            label: t(label + 'DETAILS'),
            options: {
                filter: true, sort: true, display: true,
                customBodyRenderLite: (dataIndex) => {
                    if (searchData[dataIndex]) {
                        return <span onClick={() => setOpenDetail({ id: searchData[dataIndex].id, isOpen: true })}>Detail</span>;
                    }
                }
            }
        }];
        setCustomColumn(column);
        setSearchKeyData(['autom_name', 'action_defination', 'actioneer_profile_type', 'created_at']);
    }, [searchData, setSearchKeyData]);

    return (
        <div id="credential-container">
            <Search data={data} setSearchData={setSearchData} searchKey={searchKeyData} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Button className="searchbar-button" onClick={() => setOpenCustomizeView(!openCustomizeView)}>
                        {t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}
                    </Button>
                    <Button className="searchbar-button" onClick={() => setOpenFilters(!openFilters)}>
                        {t('CONTENT.DATATABLE.TOOLBAR.FILTERS')}
                    </Button>
                </Grid>
            </Search>
            <DataTable data={searchData} customColumns={customColumn} loadingDelete={loadingDelete}
                selectableRows="multiple" onRowsDelete={handleRowsDelete} loading={loading} />
            {openCustomizeView &&
                <CustomizeView setOpen={setOpenCustomizeView} customColumn={customColumn} setCustomColumn={setCustomColumn} />
            }
            {openFilters &&
                <Filters setOpen={setOpenFilters} customColumn={customColumn} setCustomColumn={setCustomColumn} />
            }
            {openDetail?.isOpen && <ActioneerResultDetail setOpen={setOpenDetail} openDetail={openDetail} />}
            {openDelete && (
                <DeleteConfirm
                    setOpenDelete={setOpenDelete}
                    message={t("CONTENT.ALERT.DELETE-MESSAGE")}
                    deleteFunc={deleteAutoms}
                />
            )}
        </div>
    );
}

export default AlertManagement;
